(() => {
  const SECTION_ID = 'shopify-section-19205521309878';

  function getSection() {
    return document.getElementById(SECTION_ID);
  }

  function getIcon(type) {
    const icons = {
      delivery: `
        <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
          <path d="M3 7h11v6H3z"></path>
          <path d="M14 9h4l3 3v1h-7z"></path>
          <circle cx="7" cy="16" r="2"></circle>
          <circle cx="17" cy="16" r="2"></circle>
        </svg>
      `,
      cod: `
        <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
          <path d="M3 8h11v7H3z"></path>
          <path d="M14 10h4l3 3v2h-7z"></path>
          <path d="M2.6 10.3h2.2"></path>
          <path d="M2.2 12.2h2.7"></path>
          <path d="M1.8 14.1h3.1"></path>
          <circle cx="7" cy="16.5" r="1.5"></circle>
          <circle cx="18" cy="16.5" r="1.5"></circle>
          <text x="6.05" y="14.25" font-size="4.2" font-weight="700">COD</text>
        </svg>
      `,
      vat: `
        <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
          <path d="M10 4h7l3 3v7l-8 8-8-8V7z"></path>
          <circle cx="16.5" cy="7.5" r="1"></circle>
          <path d="M14.2 9.2l6-6"></path>
          <text x="9.05" y="14.25" font-size="4.2" font-weight="700">VAT</text>
        </svg>
      `,
    };

    return icons[type] || icons.delivery;
  }

  function injectWhyIcons() {
    const section = getSection();
    if (!section) return;

    section.classList.add('az-why-ready');

    const cards = section.querySelectorAll('.multicolumn-card');
    if (!cards.length) return;

    cards.forEach((card) => {
      const info = card.querySelector('.multicolumn-card__info');
      if (!info) return;

      const h3 = info.querySelector('h3');
      if (!h3) return;

      const t = (h3.textContent || '').toLowerCase();
      let iconType = 'delivery';
      if (t.includes('cod')) iconType = 'cod';
      if (t.includes('vat')) iconType = 'vat';

      // Remove ONLY our icon (don’t touch anything else)
      const old = info.querySelector(':scope > .az-why-icon');
      if (old) old.remove();

      const icon = document.createElement('span');
      icon.className = 'az-why-icon';
      icon.setAttribute('aria-hidden', 'true');
      icon.innerHTML = getIcon(iconType);

      // Put icon ABOVE heading, inside info container
      info.insertBefore(icon, info.firstChild);
    });

  }

  function init() {
    injectWhyIcons();

    // Theme editor / dynamic renders
    document.addEventListener('shopify:section:load', (e) => {
      if (e?.target?.id === SECTION_ID) injectWhyIcons();
    });

    // Safety: if Dawn re-renders blocks without section event
    const section = getSection();
    if (section) {
      const mo = new MutationObserver(() => injectWhyIcons());
      mo.observe(section, { childList: true, subtree: true });
      setTimeout(() => mo.disconnect(), 8000); // prevent endless observer
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();